import { render } from "./AccountItem.vue?vue&type=template&id=6d8ca11d&scoped=true"
import script from "./AccountItem.vue?vue&type=script&lang=ts"
export * from "./AccountItem.vue?vue&type=script&lang=ts"

import "./AccountItem.vue?vue&type=style&index=0&id=6d8ca11d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6d8ca11d"

export default script